import { memo, type RefObject } from 'react'
import type { ToolCall } from '../../../../types'
import { ToolCallListItem } from '../tools/tool-call-list-item'
import { useToolCallsMap } from '../tools/tool-calls-context'

export interface ToolPartProps {
  toolCall: ToolCall
  justRevealedRef: RefObject<Set<string>>
  expandedToolIds: Set<string>
  onOpenChange: (toolId: string, isOpen: boolean) => void
  conversationId?: string
}

/**
 * A tool call row. Resolves its own live tool call from the stable-tool-calls
 * provider — the part's embedded reference is only the fallback for renders
 * outside a provider. `useStableToolCalls` keeps unchanged calls at the same
 * object, so the memoized item below still bails when nothing changed.
 */
export const ToolPart = memo(function ToolPart({
  toolCall,
  justRevealedRef,
  expandedToolIds,
  onOpenChange,
  conversationId,
}: ToolPartProps) {
  const allToolCallsMap = useToolCallsMap()
  const liveToolCall = allToolCallsMap.get(toolCall.id) ?? toolCall

  return (
    <ToolCallListItem
      toolCall={liveToolCall}
      justRevealed={justRevealedRef.current?.has(liveToolCall.id)}
      isOpen={expandedToolIds.has(liveToolCall.id)}
      onOpenChange={onOpenChange}
      conversationId={conversationId}
    />
  )
})
